import store from '@/store'
import preferencesSetting from '@/store/modules/preferencesSetting'
import { generatorSideHoleSlot, getSawKnife } from '@/util/LayoutFuncs.js'
import {
  isSideMachineHole,
  isSideMachineMillInfo,
  isSideMachineSlot,
  toDecimal,
  truncateDecimal,
} from '@/util/commonFuncs'
import { getPlateKnifeDiameter } from '@/util/dealPaibanData'
import { getByToken } from '@/util/vueRequest'

import {
  getEdgeLengthsFromLShape,
  getPathMinMaxPoint,
  isLShapeSurplusBigPlank,
  supplementBigPlankParam,
} from './plankCommonFuncs'

// 平方毫米转换平方米
const MM2_M2 = 1000000
export function getEdgeValue(name, edgeInfo) {
  switch (name) {
    case 'LE':
      return String(edgeInfo[0] ?? 0)
    case 'BE':
      return String(edgeInfo[1] ?? 0)
    case 'RE':
      return String(edgeInfo[2] ?? 0)
    case 'TE':
      return String(edgeInfo[3] ?? 0)
  }
}

/**
 * 
 * @param {*} option 
 * {
 *  openDir: 开口方向
 *  topEdgeVal: 四个方向的值
    bottomEdgeVal
    leftEdgeVal
    rightEdgeVal
    startX
    startY
    doc
    scale
 * }
 */
export function drawPdfPlankL(option) {
  let {
    openDir,
    topEdgeVal,
    bottomEdgeVal,
    leftEdgeVal,
    rightEdgeVal,
    startX,
    startY,
    doc,
    scale,
    plankH,
    plankW,
  } = option

  switch (openDir) {
    case 'r-t': // 开口在右上（暂时只有一种情况）
      doc.path([
        {
          op: 'm',
          c: [startX, startY],
        },
        {
          op: 'l',
          c: [startX + topEdgeVal * scale, startY],
        },
        {
          op: 'l',
          c: [
            startX + topEdgeVal * scale,
            startY + (plankH - rightEdgeVal) * scale,
          ],
        },
        {
          op: 'l',
          c: [
            startX + plankW * scale,
            startY + (plankH - rightEdgeVal) * scale,
          ],
        },
        {
          op: 'l',
          c: [startX + plankW * scale, startY + plankH * scale],
        },
        {
          op: 'l',
          c: [startX, startY + plankH * scale],
        },
        {
          op: 'h',
        },
      ])
      break

    case 'l-b':
      // 注意如果是在左下方的时候，需要逆时针旋转90度
      ;[topEdgeVal, rightEdgeVal, bottomEdgeVal, leftEdgeVal] = [
        rightEdgeVal,
        bottomEdgeVal,
        leftEdgeVal,
        topEdgeVal,
      ]
      // doc.path([
      //   {
      //     op: 'm',
      //     c: [startX, startY],
      //   },
      //   {
      //     op: 'l',
      //     c: [startX + plankW * scale, startY],
      //   },
      //   {
      //     op: 'l',
      //     c: [startX + plankW * scale, startY + plankH * scale],
      //   },
      //   {
      //     op: 'l',
      //     c: [
      //       startX + (plankW - bottomEdgeVal) * scale,
      //       startY + plankH * scale,
      //     ],
      //   },
      //   {
      //     op: 'l',
      //     c: [
      //       startX + (plankW - bottomEdgeVal) * scale,
      //       startY + leftEdgeVal * scale,
      //     ],
      //   },
      //   {
      //     op: 'l',
      //     c: [startX, startY + leftEdgeVal * scale],
      //   },
      //   {
      //     op: 'h',
      //   },
      // ])
      // 此时绘制开口逻辑按照右下来
      drawPdfPlankL({
        ...option,
        rightEdgeVal,
        bottomEdgeVal,
        leftEdgeVal,
        topEdgeVal,
        openDir: 'r-b',
      })
      break
    case 'r-b':
      doc.path([
        {
          op: 'm',
          c: [startX, startY],
        },
        {
          op: 'l',
          c: [startX + plankW * scale, startY],
        },
        {
          op: 'l',
          c: [startX + plankW * scale, startY + rightEdgeVal * scale],
        },
        {
          op: 'l',
          c: [startX + bottomEdgeVal * scale, startY + rightEdgeVal * scale],
        },
        {
          op: 'l',
          c: [startX + bottomEdgeVal * scale, startY + plankH * scale],
        },
        {
          op: 'l',
          c: [startX, startY + plankH * scale],
        },
        {
          op: 'h',
        },
      ])
      break
  }
}

export function getPaibanTime(isNow = false) {
  let time = new Date().getTime()
  if (store.state.paibanTime && !isNow) {
    time = store.state.paibanTime
  }
  const date = new Date(time)
  const Y = date.getFullYear() + '-'
  const M =
    (date.getMonth() + 1 < 10
      ? '0' + (date.getMonth() + 1)
      : date.getMonth() + 1) + '-'
  const D = date.getDate() + ' '
  const h = date.getHours() + ':'
  const m = date.getMinutes() + ':'
  const s = date.getSeconds()
  const result = Y + M + D + h + m + s
  return result
}

export function handleGenFileNameStr(data, folderSetting) {
  let str = ''
  let addressArr = []
  let orderNoArr = []
  let addressOrderNoArr = []
  let orderNoAddressArr = []
  data = data.map((item) => {
    if (item.parts) {
      return item.parts
    } else {
      return item
    }
  })
  data.flat().forEach((part) => {
    if (part.address && !addressArr.includes(part.address)) {
      addressArr.push(part.address)
    }
    if (part.orderNo && !orderNoArr.includes(part.orderNo)) {
      orderNoArr.push(part.orderNo)
    }
    if (
      (part.address ?? '') + (part.orderNo ?? '') &&
      !addressOrderNoArr.includes((part.address ?? '') + (part.orderNo ?? ''))
    ) {
      addressOrderNoArr.push((part.address ?? '') + (part.orderNo ?? ''))
    }
    if (
      (part.orderNo ?? '') + (part.address ?? '') &&
      !orderNoAddressArr.includes((part.orderNo ?? '') + (part.address ?? ''))
    ) {
      orderNoAddressArr.push((part.orderNo ?? '') + (part.address ?? ''))
    }
  })
  if (folderSetting.orderCodeAsDirectionName) {
    str = orderNoArr.join(',')
  } else {
    if (
      folderSetting.wrapper_folder.length <= 1 ||
      addressOrderNoArr.length <= 1
    ) {
      folderSetting.wrapper_folder.forEach((tag) => {
        switch (tag) {
          case '项目地址':
            str += addressArr.join(',')
            break

          case '订单号':
            str += orderNoArr.join(',')
            break

          case '排版时间':
            str += getPaibanTime().replace(/\:/g, '_')
            break
          case '生产线名称':
            str += store.state.recodrProductionLineChoose
            break
          default:
            break
        }
      })
    } else if (
      folderSetting.wrapper_folder.indexOf('项目地址') <
      folderSetting.wrapper_folder.indexOf('订单号')
    ) {
      str = !folderSetting.wrapper_folder.includes('排版时间')
        ? addressOrderNoArr.join(',')
        : getPaibanTime() + addressOrderNoArr.join(',')
    } else {
      str = !folderSetting.wrapper_folder.includes('排版时间')
        ? orderNoAddressArr.join(',')
        : getPaibanTime() + orderNoAddressArr.join(',')
    }
  }
  str =
    str.length > folderSetting.max_file_name
      ? str.substring(0, folderSetting.max_file_name) + '...'
      : str
  return str
}

// 处理文件管理合并文件
function dealWrapperFolder(arr, data, toggleColon) {
  let part = store.state.paibanData[0].parts[0]
  let str = handleGenFileNameStr(
    store.state.paibanData,
    store.state.ncSetting.customizeFolder
  )
  if (toggleColon && str) {
    str = str.replace(/:/g, '_')
  }
  return {
    firstLevelFileName: str,
    data: data,
    arr,
  }
}

// 生成一级文件名
// toggleColon: 是否转化冒号
export function genFirstLevelFileName(toggleColon) {
  if (store.state.ncSetting.customizeFolder) {
    return dealWrapperFolder(
      store.state.ncSetting.customizeFolder.wrapper_folder,
      store.state.ncSetting.customizeFolder,
      toggleColon
    )
  }
  return new Promise((resolve, reject) => {
    getByToken(
      '/load_customize_folder_setting',
      {
        setting_id: store.state.ncSetting.process_setting_id,
      },
      (res) => {
        if (res.status === 1) {
          resolve(
            dealWrapperFolder(res.data.wrapper_folder, res.data, toggleColon)
          )
        } else {
          reject()
        }
      }
    )
  })
}
/**
 * @desc 判断是否展示余料标签
 * @param usedRate 使用率
 * @param usedArea 适用面积
 * @return {boolean}
 */
export function judgeIsGenerateLaveTag(usedRate, usedArea) {
  if (!preferencesSetting.state.setting?.isSurpLabelSetValue) return true
  // 剩余面积 = （使用面积 / 比率） * （ 1 - 比率）简化方程式得到下述计算代码
  const laveArea = (usedArea * (1 / usedRate - 1)) / MM2_M2
  // 如果当前余料面积小于通用设置里的面积阈值 则标签页不展示此余料标签
  if (laveArea < preferencesSetting.state.setting.surpLabelSetValue) {
    return false
  }
  return true
}

// 余料边长信息
export function getSurplusSize(surplus, ncSetting, isUseSaw) {
  const { firstCutSurplus, surplusStoreAndLabeling, processType } =
    ncSetting.sawSetting
  const { surplusPath, stockKey, realRect } = surplus
  const paths = surplusPath[0]
  const plateKnifeDiameter = getPlateKnifeDiameter(stockKey, ncSetting)
  const sawKnifeDiameter = getSawKnife(ncSetting)
  const diameter = surplus.blueAreaSurplus
    ? 0
    : isUseSaw
    ? sawKnifeDiameter
    : +plateKnifeDiameter
  const diameterR = surplus.blueAreaSurplus
    ? 0
    : firstCutSurplus &&
      surplusStoreAndLabeling &&
      processType === 'weldingPlank'
    ? diameter
    : plateKnifeDiameter
  let str = ''
  let size
  let shape
  let max_long = 0,
    min_long = 0,
    max_width = 0,
    min_width = 0
  let arr = dealNotchDir(paths, ncSetting, stockKey)
  // 异形余料处理
  if (paths.length > 7) {
    return {
      str: `${realRect.width}*${realRect.height}`,
      size: [realRect.width, realRect.height],
      shape: 2,
      max_long: realRect.height,
      min_long: 0,
      max_width: realRect.width,
      min_width: 0,
    }
  }
  if (arr.length > 2) {
    size = arr.reduce(
      (pre, cut) => {
        if (cut.dir == 'left' || cut.dir == 'right') {
          pre[0].push(parseFloat((cut.text - diameterR).toFixed(2)))
        } else {
          pre[1].push(parseFloat((cut.text - diameterR).toFixed(2)))
        }
        return pre
      },
      [[], []]
    )
    max_long = Math.max.apply(null, size[0])
    min_long = Math.min.apply(null, size[0])
    max_width = Math.max.apply(null, size[1])
    min_width = Math.min.apply(null, size[1])
    size = size.sort((a, b) => {
      a = a.sort((a, b) => b - a)
      b = b.sort((a, b) => b - a)
      const am = Math.max(a[0], a[1])
      const bm = Math.max(b[0], b[1])
      return bm - am
    })
    const [long, short] = size
    str = `${parseInt(Number(long[0]).toFixed(2))}(${parseInt(
      Number(long[1]).toFixed(2)
    )})*${parseInt(Number(short[0]).toFixed(2))}(${parseInt(
      Number(short[1]).toFixed(2)
    )})`
    shape = 1
  } else {
    let wh = arr.map((it) => +it.text - diameterR)
    wh = wh.map((item) => parseInt(item))
    size = wh
    max_long = size[1]
    max_width = size[0]
    str = wh.join('*')
    shape = 0
  }
  if (surplus.blueAreaSurplus) {
    let wh = arr.map((it) => +it.text)
    wh = wh.map((item) => parseInt(item))
    str = wh.join('*')
  }
  return {
    str,
    size,
    shape,
    max_long,
    min_long,
    max_width,
    min_width,
  }
}
// 余料长边短边的位置
export function dealNotchDir(path) {
  let xArr = [],
    yArr = []
  path.forEach((it) => (xArr.push(it.x), yArr.push(it.y)))
  const [maxX, maxY, minX, minY] = [
    Math.max(...xArr),
    Math.max(...yArr),
    Math.min(...xArr),
    Math.min(...yArr),
  ]
  if (path.length < 6 || path.length > 7) {
    return [
      { text: maxX, dir: 'width' },
      { text: maxY, dir: 'height' },
    ]
  }
  /** 四个顶点坐标  LT左上角 RT右上角 LB左下角 RB右下角*/
  const notchDir = {
    LT: { x: minX, y: minY },
    RT: { x: maxX, y: minY },
    LB: { x: minX, y: maxY },
    RB: { x: maxX, y: maxY },
  }
  /** 四个顶点坐标对应的方向值 */
  const dirKey = Object.keys(notchDir)
  /** 缺口方向 如 LT、RT、LB、RB */
  let res = ''
  for (const key of dirKey) {
    const p = notchDir[key]
    const f = path.find((it) => it.x === p.x && it.y === p.y)
    if (!f) {
      res = key
      break
    }
  }
  let midX, midY
  // 0.01 为误差值
  const findPath = path.find(
    (it) =>
      it.x > minX + 0.01 &&
      it.x < maxX - 0.01 &&
      it.y > minY + 0.01 &&
      it.y < maxY - 0.01
  )
  if (findPath) {
    midX = findPath.x
    midY = findPath.y
  }
  let left, bottom, right, top
  switch (res) {
    case 'LT':
      left = maxY - midY
      bottom = maxX
      right = maxY
      top = maxX - midX
      break
    case 'LB':
      left = midY
      bottom = maxX - midX
      right = maxY
      top = maxX
      break
    case 'RT':
      left = maxY
      bottom = maxX
      right = maxY - midY
      top = midX
      break
    case 'RB':
      left = maxY
      bottom = midX
      right = midY
      top = maxX
      break
  }
  return [
    { text: left, dir: 'left' },
    { text: bottom, dir: 'bottom' },
    { text: right, dir: 'right' },
    { text: top, dir: 'top' },
  ]
}

export const SURPLUS_TAG_TEXT_OPTIONS = [
  {
    att: '',
    type: 'FixedText',
    name: '板件材质：',
    x: 12,
    y: 12,
    fontSize: 9,
    fontWeight: 'bold',
  },
  {
    att: 'matCode',
    type: 'DataSource',
    name: '',
    x: 57,
    y: 12,
    fontSize: 9,
    fontWeight: 'bold',
  },
  {
    att: '',
    type: 'FixedText',
    name: '板件颜色：',
    x: 12,
    y: 32,
    fontSize: 9,
    fontWeight: 'bold',
  },
  {
    att: 'texture',
    type: 'DataSource',
    name: '',
    x: 57,
    y: 32,
    fontSize: 9,
    fontWeight: 'bold',
  },
  {
    att: '',
    type: 'FixedText',
    name: '板件尺寸：',
    x: 12,
    y: 52,
    fontSize: 9,
    fontWeight: 'bold',
  },
  {
    att: 'plankSize',
    type: 'DataSource',
    name: '',
    x: 57,
    y: 52,
    fontSize: 9,
    fontWeight: 'bold',
  },
]

export const TEXT_OPTIONS = [
  {
    att: '',
    type: 'FixedText',
    name: '材质：',
    x: 12,
    y: 12,
    fontSize: 9,
    fontWeight: '',
  },
  {
    att: 'matCode',
    type: 'DataSource',
    name: '',
    x: 37,
    y: 12,
    fontSize: 9,
    fontWeight: '',
  },
  {
    att: '',
    type: 'FixedText',
    name: '颜色：',
    x: 12,
    y: 27,
    fontSize: 9,
    fontWeight: '',
  },
  {
    att: 'texture',
    type: 'DataSource',
    name: '',
    x: 37,
    y: 27,
    fontSize: 9,
    fontWeight: '',
  },
  {
    att: '',
    type: 'FixedText',
    name: '板件大小：',
    x: 12,
    y: 42,
    fontSize: 9,
    fontWeight: '',
  },
  {
    att: 'plankSize',
    type: 'DataSource',
    name: '',
    x: 57,
    y: 42,
    fontSize: 9,
    fontWeight: '',
  },
  {
    att: '',
    type: 'FixedText',
    name: '板件厚度：',
    x: 12,
    y: 57,
    fontSize: 9,
    fontWeight: '',
  },
  {
    att: 'thick',
    type: 'DataSource',
    name: '',
    x: 57,
    y: 57,
    fontSize: 9,
    fontWeight: '',
  },
]

// 在旋转方法中抽取出来的对于侧孔侧槽信息的处理
export function dealRotateShotsHoles(part, nc_setting) {
  let { sslots, sholes, slots, holes } = part
  sslots = JSON.parse(JSON.stringify(sslots))
  sholes = JSON.parse(JSON.stringify(sholes))
  // sholes
  for (let k in sholes) {
    let shole = sholes[k]
    let side = shole['side']

    side = parseInt(side) + 1
    if (side <= 0) {
      side = 4
    }
    if (side >= 5) {
      side = 1
    }
    shole['side'] = side
  }

  // sslots
  for (let j in sslots) {
    let sslot = sslots[j]
    let side = sslot['side']
    side = parseInt(side) + 1
    if (side <= 0) {
      side = 4
    }
    if (side >= 5) {
      side = 1
    }

    sslot['side'] = side
  }

  let sholeInfo = generatorSideHoleSlot([
    ...sholes,
    ...holes.filter((hole) => isSideMachineHole(hole) && hole.side == 1),
  ])
  let sholeInfoF = generatorSideHoleSlot(
    holes.filter((hole) => isSideMachineHole(hole) && hole.side == -1),
    'upDownFlip'
  )
  let sslotInfo = generatorSideHoleSlot(
    [
      ...sslots,
      ...slots.filter((slot) => isSideMachineSlot(slot) && slot.side == 1),
      ...(part.millInfo
        ? part.millInfo?.filter(
            (mill) => isSideMachineMillInfo(mill) && mill.side == 1
          )
        : []),
    ],
    '',
    part
  )
  let sslotInfoF = generatorSideHoleSlot(
    slots.filter((slot) => isSideMachineSlot(slot) && slot.side == -1),
    'upDownFlip',
    part
  )

  return {
    sholes: sholeInfo,
    sholesF:
      sholeInfoF.length == 2 ? sholeInfoF.replace('翻面', '') : sholeInfoF,
    sslots: sslotInfo,
    sslotsF:
      sslotInfoF.length == 2 ? sslotInfoF.replace('翻面', '') : sslotInfoF,
  }
}

export function getGraghEdge(plank) {
  // 可能部分数据不存在 path
  supplementBigPlankParam(plank, store.state.ncSetting)
  const [minX, minY, maxX, maxY] = getPathMinMaxPoint(plank.path)
  let size = `${toDecimal(maxX - minX, 2)}*${toDecimal(maxY - minY, 2)}*${
    plank.thick
  }`
  let min_long = 0,
    min_width = 0

  // L型余料
  if (isLShapeSurplusBigPlank(plank)) {
    const {
      longestHorizontalEdge,
      secondLongestHorizontalEdge,
      longestVerticalEdge,
      secondLongestVerticalEdge,
    } = getEdgeLengthsFromLShape(plank?.path ?? [])
    min_long = secondLongestVerticalEdge.size
    min_width = secondLongestHorizontalEdge.size
    size = `${toDecimal(longestHorizontalEdge.size, 2)}(${toDecimal(
      secondLongestHorizontalEdge.size,
      2
    )})*${toDecimal(longestVerticalEdge.size, 2)}(${toDecimal(
      secondLongestVerticalEdge.size,
      2
    )})*${plank.thick}`
  }
  return {
    size,
    min_long: toDecimal(min_long, 2),
    min_width: toDecimal(min_width, 2),
  }
}

/** 处理成品尺寸此类数据的小数点位数控制 */
export function dealSizeNum(str, decimal = 2) {
  if (!str) return ''
  const a = str.split('*').map((r) => truncateDecimal(r, decimal))
  return a.join('*')
}
